module.exports = __webpack_public_path__ + "img/trading-station.72b3a9ee.svg";